export function promiseWrapper (fn, onError) {
  return function (dispatch) {
    fn(dispatch).catch(error => onError && dispatch(onError(error)))
  }
}
